import { Serializable } from './serializable';

export class EmptyData implements Serializable<EmptyData> {
  toObject() {
    throw new Error('Method not implemented.');
  }

  public fromObject(obj: any): EmptyData {
    return this;
  }
}
